import React, { useCallback, useState } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NotesPanel from './NotesPanel';
import ActivityList from '../activity/ActivityList';

const TAB_KEY = 'SD_JOB_HISTORY_TAB';

/**
 * A job's history in one card: notes people wrote (default tab) and the activity log the system keeps.
 * The notes panel stays mounted so its count and an unsent draft survive switching tabs; the last tab is remembered.
 */
export default function JobHistoryCard({ jobId, reloadKey }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(() => { try { return localStorage.getItem(TAB_KEY) || 'notes'; } catch { return 'notes'; } });
    const [count, setCount] = useState(null);
    const [notesVersion, setNotesVersion] = useState(0);
    const onCount = useCallback((n) => setCount(n), []);
    const change = (_, v) => { setTab(v); try { localStorage.setItem(TAB_KEY, v); } catch { /* ignore */ } };

    return (
        <Paper elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '14px', overflow: 'hidden', mt: 2.5 }}>
            <Tabs value={tab} onChange={change} sx={{
                px: 1.5, borderBottom: '1px solid #F1F5F9', minHeight: 48,
                '& .MuiTab-root': { textTransform: 'none', fontWeight: 700, fontSize: 14, minHeight: 48 },
            }}>
                <Tab value="notes" label={count ? `${t('notes.title')} (${count})` : t('notes.title')} />
                <Tab value="activity" label={t('activity.title')} />
            </Tabs>
            <Box sx={{ display: tab === 'notes' ? 'block' : 'none' }}>
                <NotesPanel jobId={jobId} reloadKey={reloadKey} onCount={onCount} onChanged={() => setNotesVersion(v => v + 1)} />
            </Box>
            {tab === 'activity' && <ActivityList jobId={jobId} reloadKey={`${reloadKey}-${notesVersion}`} />}
        </Paper>
    );
}
